import * as ActionType from "./organization.type";

const initialState = {
  orgProfile: {},
  organizations: [],
  totalOrganizations: 0,
  selectedOrganization: null,
};

export const organizationReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.GET_ORGANIZATIONS:
      return {
        ...state,
        organizations: action.payload.organizations,
        totalOrganizations: action.payload.totalOrganizations,
      };

    case ActionType.ADD_ORGANIZATION:
      return {
        ...state,
        organizations: [action.payload, ...state.organizations],
        selectedOrganization: action.payload,
        totalOrganizations: state.totalOrganizations + 1,
      };

    case ActionType.UPDATE_ORGANIZATION:
      const { organizationId, updatedData } = action.payload;
      return {
        ...state,
        organizations: state.organizations.map((org) =>
          org.id === organizationId ? { ...org, ...updatedData } : org
        ),
        selectedOrganization:
          state.selectedOrganization?.id === organizationId
            ? { ...state.selectedOrganization, ...updatedData }
            : state.selectedOrganization,
      };

    case ActionType.DELETE_ORGANIZATION:
      return {
        ...state,
        organizations: state.organizations.filter(
          (org) => org.id !== action.payload
        ),
        totalOrganizations: state.totalOrganizations - 1,
        selectedOrganization:
          state.selectedOrganization?.id === action.payload
            ? null
            : state.selectedOrganization,
      };

    case ActionType.SELECT_ORGANIZATION:
      return {
        ...state,
        selectedOrganization: action.payload,
      };

    case ActionType.TOGGLE_ORGANIZATION_STATUS:
      const { organizationId: toggleOrgId } = action.payload;
      return {
        ...state,
        organizations: state.organizations.map((org) =>
          org.id === toggleOrgId ? { ...org, status: !org.status } : org
        ),
        selectedOrganization:
          state.selectedOrganization?.id === toggleOrgId
            ? {
                ...state.selectedOrganization,
                status: !state.selectedOrganization.status,
              }
            : state.selectedOrganization,
      };

    case ActionType.GET_ORG_PROFILE:
      return {
        ...state,
        orgProfile: action.payload,
      };

    case ActionType.UPDATE_ORG_PROFILE:
      return {
        ...state,
        orgProfile: action.payload,
      };

    default:
      return state;
  }
};
